import { fromJS } from 'immutable';

import {
  GET_SKILLSET_OPTIONS_OF_TYPE_SUCCESS,
  RESET_SKILLSET_STATE,
} from '../actions/actionTypes';

const initialState = fromJS({
  build: [],
  look: [],
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SKILLSET_OPTIONS_OF_TYPE_SUCCESS:
      // console.log('RECEIVED SKILLSET', action.value);
      return state.set(action.skillsetType, fromJS(action.value));
    case RESET_SKILLSET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
